export default __webpack_public_path__ + "static/media/my-task-light.e1138b05.svg";